import { SiteInformation, FeatureSwitchDto, MyleInstanceClinicSettings } from "../../dtos/KioskDtos.dtos";
import { LanguageLocaleService } from "../../services/Language/LanguageService";
import { LanguageCodes } from "../../constants/languages";
import { ILabelSelect } from "../../services/Language/Types";
import { AdminSettingsValues } from "../../store/AdminOptions/type";
import { StartApplicationPayload } from "../../sagas/ApplicationAsyncSagas/types";

export class AdminOption {
    public title: string;
    public text: string;
    public type: string;
    public changeFunction: (value: boolean | number) => void;
    constructor(
        title: string,
        text: string,
        type: string,
        changeFunction: (value: boolean | number) => void
    ) {
        this.title = title;
        this.text = text;
        this.type = type;
        this.changeFunction = changeFunction;
    }
}

export class FlowOption extends AdminOption {
    public selected: boolean;
    public disabled: boolean;
    public constructor(
        title: string,
        text: string,
        selected: boolean,
        disabled: boolean,
        changeFunction: (value: boolean) => void
    ) {
        super(title, text, "FlowOption", changeFunction);
        this.selected = selected;
        this.disabled = disabled;
    }
}

export class SettingOption extends AdminOption {
    public value: number;
    public options: ILabelSelect[];
    public isInvalid: boolean;
    public constructor(
        title: string,
        text: string,
        value: number,
        options: ILabelSelect[],
        changeFunction: (value: number) => void,
        isInvalid: boolean = false
    ) {
        super(title, text, "SettingOption", changeFunction);
        this.value = value;
        this.options = options;
        this.isInvalid = isInvalid;
    }
}

export interface IAdminSetupMapDispatchProps {
    startApplication: (payload: StartApplicationPayload, inactivityDelay: number) => void;
    returnToLoginPage: () => void;
    toggleAbleToViewAndModifyPatientInfo: (value: boolean) => void;
    toggleRegionCodeConfirmationRequired: (value: boolean) => void;
    toggleDisplayProfilePictures: (value: boolean) => void;
    toggleHealthCardExpirationRedirectToReception: (value: boolean) => void;
    toggleAbleToViewAndModifyPreferredPharmacy: (value: boolean) => void;
    onLanguageSelectionChange: (checked: boolean, langCode: LanguageCodes) => void;
    selectCurrentSiteFromList: (currentSiteId: string) => void;
    onSiteSelectionChange: (checked: boolean, value: string | number) => void;
    changeDefaultLanguage: (lang: LanguageCodes) => void;
    changeAppointmentTimeRange: (fieldName: string, value: number) => void;
    changeAdminSettingNumberField: (fieldName: string, value: number) => void;
}

export interface IAdminSetupMapStateProps {
    lang: string;
    textLibrary: LanguageLocaleService;
    isUserAuthenticated: boolean;
    ableToSeeAndModifyExistingPatientData: boolean;
    ableToSeeAndModifyExistingPreferredPharmacy: boolean;
    regionCodeConfirmationRequired: boolean;
    displayProfilePicture: boolean;
    healthCardExpiryRedirect: boolean;
    clinicSiteName: string;
    sitesOptions: ILabelSelect[];
    sites: SiteInformation[];
    currentSelectedSite: string;
    selectedLanguages: Set<LanguageCodes>;
    selectedSites: Set<string>;
    defaultLanguage: LanguageCodes;
    settingValues: AdminSettingsValues;
    featureSwitch: FeatureSwitchDto;
    clinicSettings: MyleInstanceClinicSettings;
    isLoadingSpinnerActive: boolean;
}
export type IAdminSetupProps = IAdminSetupMapDispatchProps & IAdminSetupMapStateProps;



// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Types.tsx